export default "__VITE_ASSET__ZZNbkD7i__"